import { Component, defineComponent } from '@decify/cell-shopify/client';
import './TextField.scss';
export const textFieldName = 'TextField';
export const textFieldTagName = 'cell-component-text-field';
export const textFieldChangeEvent = 'change';
export class TextField extends Component {
    elements;
    constructor() {
        super(textFieldName);
        const inputElement = this.querySelector('input, textarea');
        if (!inputElement) {
            throw new Error('Input or textarea element not found');
        }
        if (!(inputElement instanceof HTMLInputElement) &&
            !(inputElement instanceof HTMLTextAreaElement)) {
            throw new Error('Element is not an input or textarea element');
        }
        this.elements = {
            input: inputElement,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.elements.input.subscribe('input', this.handleInputChange);
        this.elements.input.subscribe('change', this.handleInputChange);
    }
    handleInputChange() {
        this.publish(textFieldChangeEvent, { value: this.elements.input.value, element: this });
    }
}
defineComponent(textFieldTagName, TextField);
